import { createSelector } from 'reselect';

export const mapLocaleSelector = createSelector(
  state => state.intl.locale,
  locale => (locale === 'ru' ? 'ru_RU' : 'en_US'),
);
